import PersonCard from './person_card';

export default PersonCard;
